import { ITopsItem } from './tops.interface';

export const topItems: ITopsItem[] = [
  {
    title: 'Топ 100 авторов',
    link: '/top100_authors',
  },
  {
    title: 'Топ 100 книг',
    link: '/top100_books',
  },
  {
    title: 'Топ 100 книг, оцениваемых чаще всего',
    link: '/top100_often_rated_books',
  },
  {
    title: 'Топ 100 книг, которые оценили выше всего',
    link: '/top100_rated_books',
  },
  {
    title: 'Авторы, которых ищут чаще всего (за все время)',
    link: '/top100_searched_authors',
  },
  {
    title: 'Рейтинг книг, которые ищут наиболее часто (за все время)',
    link: '/top100_searched_books',
  },
];
